import { Box, Skeleton } from "@mui/material";

import { g } from "./shared/tokens";

const WeeklyConsistencyChallengeLoading = () => {
  return (
    <Box
      sx={{
        background: g.panelBg,
        border: `1px solid ${g.border}`,
        borderRadius: g.radiusXl,
        p: { xs: "20px", md: "28px" },
        maxWidth: 1000,
      }}
    >
      {/* Header skeleton */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: "18px",
        }}
      >
        <Box>
          <Skeleton variant="text" width={260} height={28} />
          <Skeleton variant="text" width={320} height={20} />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: "6px",
          }}
        >
          <Skeleton
            variant="rounded"
            width={120}
            height={24}
            sx={{ borderRadius: "999px" }}
          />
          <Skeleton variant="text" width={90} height={16} />
        </Box>
      </Box>

      {/* Inner card skeleton */}
      <Box
        sx={{
          background: g.cardBg,
          border: `1px solid ${g.border}`,
          borderRadius: g.radiusLg,
          p: { xs: "16px", md: "22px" },
        }}
      >
        <Skeleton
          variant="rounded"
          width="100%"
          height={64}
          sx={{ borderRadius: g.radiusMd }}
        />
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "repeat(4, 1fr)" },
            gap: "10px",
            mt: "18px",
          }}
        >
          {[1, 2, 3, 4].map((i) => (
            <Skeleton
              key={i}
              variant="rounded"
              height={96}
              sx={{ borderRadius: g.radiusMd }}
            />
          ))}
        </Box>
        <Box
          sx={{ display: "flex", justifyContent: "space-between", mt: "22px" }}
        >
          <Skeleton variant="text" width={150} height={20} />
          <Skeleton variant="text" width={90} height={20} />
        </Box>
        <Skeleton
          variant="rounded"
          width="100%"
          height={8}
          sx={{ borderRadius: "999px", mt: "8px" }}
        />
        <Skeleton
          variant="rounded"
          width="100%"
          height={42}
          sx={{ borderRadius: g.radiusSm, mt: "16px" }}
        />
      </Box>
    </Box>
  );
};

export default WeeklyConsistencyChallengeLoading;
